export default __webpack_public_path__ + "static/cruiselines-carnival-activities-6-c85976fa0aabba2f533603bdf4a0a9d3.jpg";